import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBarDropdownButton from 'components/Navigations/NavBarDropdownButton/NavBarDropdownButton';
import NavBarDropDownMenu from 'components/Navigations/NavBarDropDownMenu/NavBarDropDownMenu';
import userDropDownPlaceHolder from 'assets/img/placeholders/user_dropdown_button.svg';
import { DropdownItemList } from 'commons/DropdownMenuItems';
import './NavBarDropDown.scss';


export class NavBarDropDown extends Component {

  constructor(props) {
    super(props)
    this.state = { isActive: false };
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }
  
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }
  
  handleClickOutside = event => {
    const domNode = this.containerRef.current;
  
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({ isActive: false });
    }
  }

  onDropdownButtonClick = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  render() {
    const { currentUserData, theme="default" } = this.props;
    const { isActive } = this.state;
    return (
      <div className={`navbar-dropdown ${isActive ? 'active' : ''}`} ref={this.containerRef}>
        <div className="navbar-dropdown__button">
          { currentUserData && currentUserData.firstName ?
            <NavBarDropdownButton isActive={isActive} theme={theme} onDropdownButtonClick={this.onDropdownButtonClick} />:
            <img src={userDropDownPlaceHolder} />
          }
        </div>
        <div className="navbar-dropdown__menu">
          <NavBarDropDownMenu itemList={DropdownItemList} theme={theme} isActive={isActive} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const { rootReducers } = store;
  const { userDataReducers } = rootReducers;
  return {
    currentUserData: userDataReducers.currentUserData
  };
};


export default connect(mapStateToProps)(NavBarDropDown);
